export default "__VITE_ASSET__BACB8U4h__"